import { motion, useScroll, useTransform } from "framer-motion";
import heroTextImage from "../../assets/images/image20.png";
import heroImage from "../../assets/images/hero-image-12.jpg";
import heroImage2 from "../../assets/images/hero-image-26.jpg";
import { ArrowUpRight } from "lucide-react";
import img1 from "../../assets/images/services/img2.png";
import img2 from "../../assets/images/services/img5.jpeg";
import img3 from "../../assets/images/services/img3.jpeg";
import img4 from "../../assets/images/services/img6.jpg";
import img5 from "../../assets/images/services/img8.jpeg";
import img6 from "../../assets/images/hero-image-13.jpg";
import { useRef } from "react";

const services = [
  { number: "01", title: "Luxury Mountaineering", description: "Comfort & elite climbing.", image: img1 },
  { number: "02", title: "14 Peaks Basecamp Trekking", description: "Basecamp trekking tours.", image: img2 },
  { number: "03", title: "Expeditions", description: "Hardcore summit expeditions.", image: img3 },
  { number: "04", title: "Trekking Experiences", description: "Scenic nature adventures.", image: img4 },
  { number: "05", title: "Trainings", description: "Skill development program.", image: img5 },
  { number: "06", title: "Adventure Packages", description: "Mixed adventure thrill.", image: img6 },
];

export default function TeamPage() {
  /* ======================
     PARALLAX SETUPS
     ====================== */
  const heroRef = useRef(null);


  const heroScroll = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const heroY = useTransform(heroScroll.scrollYProgress, [0, 1], ["0%", "30%"]);


  return (
    <main className="bg-black overflow-x-hidden">
     <section
        ref={heroRef}
        className="relative w-screen overflow-hidden bg-[#faf9f6]
        h-[520px]
       "
      >
        {/* PARALLAX IMAGE */}
        <motion.div style={{ y: heroY }} className="absolute inset-0">
          <motion.img
            src={heroImage}
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover opacity-85"
            initial={{ scale: 1.05 }}
            animate={{ scale: 1.15, x: -20, y: -30 }}
            transition={{
              duration: 8,
              repeat: Infinity,
              repeatType: "mirror",
              ease: "linear",
            }}
          />
        </motion.div>

    

        {/* HERO TEXT — FIXED VISUAL BAND */}
          <div
            className="
              absolute left-1/2
              w-full px-6 text-center z-10 backdrop-blur-sm
              -translate-x-1/2 -translate-y-1/2
            "
            style={{
              top: "calc(50% + 2.5rem)",
            }}
          >

          <motion.h1
            className="font-extrabold leading-none tracking-tight select-none text-[14vw] md:text-[10vw]"
            animate={{ backgroundPosition: ["0% 50%", "200% 50%"] }}
            transition={{ duration: 80, ease: "linear", repeat: Infinity }}
            style={{
              backgroundImage: `url(${heroTextImage})`,
              backgroundSize: "300% auto",
              backgroundRepeat: "repeat-x",
              backgroundPosition: "0% 50%",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
           
              color: "transparent",
              WebkitTextFillColor: "transparent",
            }}
          >
            <span className="block">MOUNTAIN</span>
            <span className="block">EXPERIENCES</span>
          </motion.h1>
        </div>
      </section>

      {/* ======================
         SERVICES
         ====================== */}
        <section
        className="
            relative w-screen
            px-6 md:px-10
            py-32 md:py-40
            overflow-visible
            bg-cover bg-center
            bg-scroll lg:bg-fixed
        "
        style={{
            backgroundImage: `url(${heroImage})`,
        }}
        >
        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-[#162230]/80 z-0" />

        {/* CONTENT */}
        <div className="relative z-10 max-w-[1600px] mx-auto">

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">

            {/* LEFT TEXT */}
            <div className="lg:col-span-4 text-center lg:text-left">
                <p className="mb-4 text-sm text-neutral-400">
                OUR SERVICES
                </p>
                <h2 className="text-[34px] md:text-[42px] font-semibold text-white">
                What We Offer
                </h2>
            </div>

            {/* SERVICES GRID */}
            <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                {services.map((service) => (
                <motion.div
                    key={service.number}
                    whileHover={{ scale: 1.01 }}
                    className="relative overflow-hidden aspect-[4/5] md:aspect-auto md:h-[520px] border border-gray-300/40 
                     shadow-xl rounded-3xl"
                >
                    <img
                    src={service.image}
                    className="absolute inset-0 w-full h-full object-cover"
                    alt={service.title}
                    />

                    <div className="absolute bottom-6 left-6 right-6 rounded-xl bg-white/10 p-5 text-white backdrop-blur">
                    <p className="text-2xl opacity-80">{service.number}</p>
                    <p className="font-medium text-lg md:text-xl">
                        {service.title}
                    </p>
                    <p className="opacity-80 text-sm md:text-base">
                        {service.description}
                    </p>
                    </div>

                   <button
                      className="
                        absolute right-4 top-4
                        inline-flex items-center gap-1.5
                        rounded-full
                        bg-white/20
                        px-4 py-2
                        text-sm
                        font-medium
                        tracking-wide
                        text-gray-800
                        backdrop-blur
                        transition
                        hover:bg-white/30
                      "
                    >
                      View
                      <ArrowUpRight className="h-3.5 w-3.5" />
                    </button>

                </motion.div>
                ))}
            </div>

            </div>
        </div>
        </section>

      {/* ======================
         JOIN SECTION
         ====================== */}
   <section className="relative w-screen px-6 md:px-10 py-32 md:py-40 overflow-hidden bg-slate-900">

  {/* ===== BASE BACKGROUND IMAGE ===== */}
  <motion.div
    className="absolute inset-0 bg-cover bg-center opacity-50"
    style={{ backgroundImage: `url(${heroImage})` }}
    initial={{ scale: 1.05, y: 0 }}
    animate={{ scale: 1.15, y: -40 }}
    transition={{
      duration: 18,
      repeat: Infinity,
      repeatType: "reverse",
      ease: "easeInOut",
    }}
  />

  {/* ===== WATERMARK TYPOGRAPHY ===== */}
{/* ===== WATERMARK TYPOGRAPHY ===== */}
<div className="pointer-events-none absolute inset-0 z-[2]">

  {/* ===== MOBILE + TABLET (CENTERED, STACKED) ===== */}
  <div className="
    absolute inset-0
    flex flex-col items-center justify-center
    gap-6
    md:gap-10
    lg:hidden
  ">
    <span className="
      font-extrabold
      tracking-tight
      select-none
      text-white/15
      leading-none
      text-[clamp(4rem,10rem,10rem)]
    ">
      PEAK
    </span>

    <span className="
      font-extrabold
      tracking-tight
      select-none
      text-white/15
      leading-none
      text-[clamp(3.5rem,10rem,10rem)]
    ">
      PREP
    </span>
  </div>

  {/* ===== DESKTOP (DECORATIVE POSITIONS) ===== */}
 {/* ===== DESKTOP WATERMARK ===== */}
<div className="hidden lg:block absolute inset-0 z-[2] pointer-events-none">

  {/* PEAK */}
  <span
    className="
      absolute
      font-extrabold
      tracking-tight
      select-none
      leading-none
      text-white/10
      text-[clamp(8rem,22vw,18rem)]
    "
    style={{
      left: "clamp(1rem, 4vw, 4rem)",
    }}
  >
    PEAK
  </span>

  {/* PREP */}
  <span
    className="
      absolute
      font-extrabold
      tracking-tight
      select-none
      leading-none
      text-white/10
      text-[clamp(7rem,20vw,18rem)]
    "
    style={{
     top: "clamp(19vh, 31vh, 35vh)",
      right: "clamp(1rem, 5vw, 5rem)",
    }}
  >
    PREP
  </span>

</div>


</div>


  {/* ===== FROSTED ICE LAYER ===== */}
  <div className="absolute inset-0 bg-white/10" />

  {/* ===== CONTENT ===== */}
  <div className="
    relative z-[3]
    grid grid-cols-1 lg:grid-cols-12
    gap-12 lg:gap-16
    text-center lg:text-left
  ">

    {/* LEFT */}
    <div className="lg:col-span-4">
      <p className="
        mb-4 tracking-wide text-neutral-300
        text-[clamp(0.9rem,2.5vw,1.125rem)]
      ">
        Dream Higher Go Further
      </p>

      <h2 className="
        font-semibold tracking-tight text-white
        text-[clamp(2.2rem,6vw,3.5rem)]
      ">
        Walk the Path With Us
      </h2>
    </div>

    {/* RIGHT */}
    <div className="
      lg:col-span-6
      space-y-6
      text-neutral-200
      mx-auto lg:mx-0
      max-w-[640px] lg:max-w-none
    ">
      <h3 className="
        font-semibold tracking-tight text-white
        text-[clamp(1.6rem,4.5vw,2.25rem)]
      ">
        Join the Journey
      </h3>

      <p className="text-[clamp(1rem,3vw,1.125rem)]">
        We create unforgettable mountain experiences for those who seek
        challenge, discovery, and connection with the world’s most
        breathtaking landscapes.
      </p>

      <p className="text-[clamp(0.95rem,2.8vw,1rem)]">
        If you’re driven by adventure and believe in crafting meaningful
        journeys, we’d love to climb higher together.
      </p>
    </div>

  </div>
</section>



      {/* ======================
         CTA
         ====================== */}
      <section
        className="relative h-[600px] w-screen overflow-hidden"
      >
        <motion.img
          src={heroTextImage}
          className="absolute inset-0 h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-black/40" />

        <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-6">
          <h2 className="max-w-[760px] text-[42px] uppercase font-semibold leading-tight tracking-tight">
            Crafted mountain experiences,
            designed for those who seek more than the summit.
          </h2>

          <a
            href="./contact"
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-white/20 px-8 py-4 text-sm font-medium tracking-wide backdrop-blur"
          >
            Talk With Our Team
            <ArrowUpRight className="h-4 w-4" />
          </a>

        </div>
      </section>

    </main>
  );
}
